/**
 * Acesso tipado às variáveis de ambiente do Vite.
 *
 * `import.meta.env.VITE_*` são definidas em build-time (não em runtime).
 * Lidas via `vite-env.d.ts` (interface ImportMetaEnv).
 *
 * `getRequiredEnv` falha cedo no boot — melhor crashar imediato do que
 * tentar fetch numa URL `undefined` e debugar erro estranho depois.
 */

function getRequiredEnv(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Variável de ambiente obrigatória ausente: ${key} (definir em build-time, p.ex. .env.local)`,
    );
  }
  return value;
}

function getOptionalEnv(key: keyof ImportMetaEnv, fallback = ''): string {
  const value = import.meta.env[key];
  return typeof value === 'string' ? value : fallback;
}

export const env = {
  API_BASE_URL: getRequiredEnv('VITE_API_BASE_URL'),
  WS_BASE_URL: getRequiredEnv('VITE_WS_BASE_URL'),
  ERP_BASE_URL: getOptionalEnv('VITE_ERP_BASE_URL'),
  AUTH_MODE: getOptionalEnv('VITE_AUTH_MODE', 'legacy') as 'legacy' | 'cognito',
  BUILD_VERSION: getOptionalEnv('VITE_BUILD_VERSION', 'dev'),
  IS_DEV: import.meta.env.DEV,
} as const;

export type AuthMode = (typeof env)['AUTH_MODE'];
